export default __webpack_public_path__ + "static/media/5143.6f223a70.png";